module.exports = __webpack_public_path__ + "d34d90aafdfe79db2ed427303771716c.MP3";